export class AppliedAdjustmentErrorResponse {
  adjustmentToParameter: any;
  'uncontrolledTransaction.transactionId': any;
  justification: any;
}
